<script setup lang="ts">
import type { Component } from "vue";
import DefaultButton from "@/components/Buttons/DefaultButton.vue";

type Props = {
  emoji?: string;
  title?: string;
  description?: string;
  actionText?: string;
  actionIcon?: Component;
  actionColor?: "blue" | "red" | "yellow";
};

type Emits = {
  (e: "action"): void;
};

const {
  emoji = "💬",
  title,
  description,
  actionText,
  actionIcon,
  actionColor = "yellow",
} = defineProps<Props>();

const emit = defineEmits<Emits>();
</script>

<template>
  <div
    class="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-gray-300 bg-slate-50/50 p-8 text-center dark:border-slate-700 dark:bg-kekkle-dark-light/50"
  >
    <slot name="emoji">
      <p class="text-4xl">{{ emoji }}</p>
    </slot>

    <h3
      v-if="title"
      class="mt-3 text-lg font-bold text-kekkle-dark dark:text-slate-100"
    >
      {{ title }}
    </h3>

    <p
      v-if="description"
      class="mt-1 text-sm text-gray-500 dark:text-slate-400"
    >
      {{ description }}
    </p>

    <slot>
      <slot name="action">
        <DefaultButton
          v-if="actionText"
          class="mt-5"
          :color="actionColor"
          @click="emit('action')"
        >
          <div class="flex items-center gap-2">
            <component :is="actionIcon" v-if="actionIcon" class="h-4 w-4" />
            <span>{{ actionText }}</span>
          </div>
        </DefaultButton>
      </slot>
    </slot>
  </div>
</template>
